import { render } from "./History.vue?vue&type=template&id=5f10e17b&scoped=true&ts=true"
import script from "./History.vue?vue&type=script&lang=ts"
export * from "./History.vue?vue&type=script&lang=ts"

import "./History.vue?vue&type=style&index=0&id=5f10e17b&lang=scss&scoped=true"
import "./History.vue?vue&type=style&index=1&id=5f10e17b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f10e17b"]])

export default __exports__